import React, { useState } from "react";
import { Checkbox, DialogActions, Grid } from "@material-ui/core";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import Translator from "Languages/Utility/Translator";
import DialogContent from "@material-ui/core/DialogContent";
import { Alert } from "@material-ui/lab";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { read } from "Helpers/LocalStorage";
import UserService from "Services/http/endpoints/user/UserService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import { ReactSVG } from "react-svg";
import infoIcon from "Assets/svg/icon/info.svg";
import InvoiceAccessIcon from "Assets/svg/icon/InvoiceAccess_nv.svg";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function UserAccessFactor({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handleDialog = () => {
    setShowDialog(!showDialog);
  };

  const onChangeCheckbox = (id, value, sub = false, sub_key) => {
    if (!sub) {
      setData(
        data.map((item) => {
          if (item.key === id) {
            item.value = value;
          }
          return item;
        })
      );
    } else {
      setData(
        data.map((item) => {
          if (item.key === id) {
            item.items.map((inner) => {
              if (inner.key === sub_key) inner.value = value;
              return inner;
            });
          }
          return item;
        })
      );
    }
  };

  const onChangeCheckbox_SelectAll = (e, name, key) => {
    setData(
      data.map((item) => {
        if (item.key === key) {
          item.items.map((inner) => {
            inner.value = true;
            return inner;
          });
        }
        return item;
      })
    );
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeySelect: row.Key,
      };
      const response = await UserService.getListActiveModelFactor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const updateData = response.data.Value.map((item) => {
          let items = Object.keys(item)
            .filter((key) => !["Id", "Checked", "Name"].includes(key))
            .map((key) => {
              return {
                value: item[key],
                label: key,
                key: key,
              };
            });
          return {
            value: item.Checked,
            label: item.Name,
            key: item.Id,
            items,
          };
        });
        setData(updateData);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await UserService.postAccessFactor({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeySelect: row.Key,
        Factors: data
          .filter((item) => item.value)
          .map((item) => {
            let _data = { id: item.key };
            item.items.map((inner) => {
              _data[inner.key] = inner.value;
            });
            return _data;
          }),
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: t("mission_accomplished"),
          customClass: "success",
        });
      }
      handleDialog();
      setLoading(false);
    } catch (e) {
      showNotify({
        text: t("UpdateError"),
        customClass: "error",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="userAccessFactor" />}
        icon={<ReactSVG src={InvoiceAccessIcon} />}
        className="warning-fill"
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="userAccessFactor" />
            </p>
          </div>
          <BackDropLoading loading={loading} />
          <DialogContent
            className={direction === "rtl" ? "text-right" : "text-left"}
          >
            <Grid container>
              <Grid item xs={12} className="mb-2">
                <Alert
                  severity="info"
                  variant="outlined"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  {`${t("name")} : ${row.DisplayName} | ${t("role")} : ${
                    row.NameStype
                  }`}
                </Alert>
              </Grid>
            </Grid>
            {!loading ? (
              <Grid container spacing={2} className="my-3 px-2">
                {data &&
                  data.map((item) => {
                    return (
                      <Grid
                        container
                        spacing={2}
                        className="mb-4"
                        style={{
                          border: "1px solid #dfe0e7",
                          borderRadius: "8px",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          className="d-flex flex-row align-items-center  g-2 "
                        >
                          <Checkbox
                            id={`checkbox-${item.key}`}
                            checked={item.value}
                            onChange={(e) =>
                              onChangeCheckbox(
                                item.key,
                                e.currentTarget.checked
                              )
                            }
                          />
                          <label
                            htmlFor={`checkbox-${item.key}`}
                            className="m-0"
                          >
                            <strong>{item.label}</strong>
                          </label>
                        </Grid>
                        {item.value && (
                          <Grid item xs={12} className="">
                            <MuiCheckBoxGroup
                              name="parts"
                              label={<Translator id={"parts"} />}
                              items={item.items}
                              selectAllShow
                              onSelectAll={(e, name) =>
                                onChangeCheckbox_SelectAll(e, name, item.key)
                              }
                              onChange={(e, name, childIndex, parentIndex) =>
                                onChangeCheckbox(
                                  item.key,
                                  e.currentTarget.checked,
                                  true,
                                  parentIndex.label
                                )
                              }
                              className="horizontalCheckbox"
                              translate
                            />
                          </Grid>
                        )}
                      </Grid>
                    );
                  })}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={6} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default UserAccessFactor;
